import { yupResolver } from "@hookform/resolvers/yup";
import { VStack } from "native-base";
import React from "react";
import { useForm } from "react-hook-form";
import { TextInputMask } from "react-native-masked-text";

import FormButton from "@/components/atoms/FormButton";
import TextInput from "@/components/atoms/TextInput";
import FormField from "@/components/molecules/FormField";
import Modal from "@/components/molecules/Modal";

import { CompanyFormData, companySchema } from "../schema";
import { ProfileEditModalProps } from "../types";

const CompanyProfileEditModal = ({
  isOpen,
  isSubmiting,
  currentData,
  onClose,
  onSubmit,
}: ProfileEditModalProps<CompanyFormData>) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<CompanyFormData>({
    resolver: yupResolver(companySchema),
    defaultValues: currentData,
  });

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      Header="Editar dados"
      Body={
        <VStack>
          <FormField
            control={control}
            name="nome"
            label="Nome fantasia"
            required
            error={errors.nome}
            render={(value, onChange) => (
              <TextInput value={value} onChangeText={onChange} placeholder="Nome fantasia" />
            )}
          />
          <FormField
            control={control}
            name="razao_social"
            label="Razão social"
            required
            error={errors.razao_social}
            render={(value, onChange) => (
              <TextInput value={value} onChangeText={onChange} placeholder="Razão social" />
            )}
          />
          <FormField
            control={control}
            name="telefone"
            label="Telefone"
            required
            error={errors.telefone}
            render={(value, onChange) => (
              <TextInputMask
                value={value}
                onChangeText={onChange}
                customTextInput={TextInput}
                type={"cel-phone"}
                options={{
                  maskType: "BRL",
                  withDDD: true,
                  dddMask: "(99) ",
                }}
                placeholder="Telefone"
              />
            )}
          />
        </VStack>
      }
      Footer={
        <VStack w="full">
          <FormButton mt="4" isLoading={isSubmiting} onPress={handleSubmit(onSubmit)}>
            Editar
          </FormButton>
          <FormButton
            colorScheme="white"
            textColor="primary.700"
            my="4"
            shadow="2"
            onPress={onClose}>
            Cancelar
          </FormButton>
        </VStack>
      }
    />
  );
};

export default CompanyProfileEditModal;
